module.exports = __webpack_public_path__ + "img/chinesecompany149.9324b231.png";